import { createStore } from 'redux'
import IMember from 'types/IMember'
import reducer from './reducers'


export type StoreState = {
  member: IMember
}

const store = createStore(reducer)

export default store